import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { AppInitializationService } from 'app/app-initialization.service';
import { Container } from 'app/models/container.model';
import { ToasterService } from 'app/services/user-interaction/services/toaster.service';
import * as L from 'leaflet';
import 'leaflet-draw';
const iconUrl = 'assets/img/marker-icon.png';
const Defaulticon = L.icon({
    iconUrl,
    iconSize: [25, 25],
    iconAnchor: [5, 20],
    popupAnchor: [1, -34],
    tooltipAnchor: [16, -28]
});
const ContainerFormIcon = L.Icon.extend({
    options: {
        iconSize: [25, 25],
        iconAnchor: [5, 20],
        popupAnchor: [1, -34],
        tooltipAnchor: [16, -28]
    }
})
L.Marker.prototype.options.icon = Defaulticon;

@Component({
    selector: 'app-generic-map-routing',
    templateUrl: './generic-map-routing.component.html',
    styleUrls: ['./generic-map-routing.component.scss']
})
export class GenericMapRoutingComponent implements OnInit {

    private map;
    public order : Array<number>;
    constructor(
        public dialogRef: MatDialogRef<GenericMapRoutingComponent>,
        public _translateService: TranslateService,
        private appConfigService: AppInitializationService,
        @Inject(MAT_DIALOG_DATA) public data: Array<Container>,
        public _toastService: ToasterService
    ) {
    }

    async ngOnInit(): Promise<void> {
        await this.initMap();
        await this.drawPoligons();
    }


    public get MapTileUrl(): string {
        return 'http://tile.openstreetmap.org/{z}/{x}/{y}.png';
    }

    private async initMap(): Promise<void> {

        this.map = L.map('map', {
            center: [39.09766, 34.56039],
            zoom: 8
        });

        const tiles = L.tileLayer(
            this.MapTileUrl, {
            maxZoom: 19,
            minZoom: 5,
            attribution: 'AKILLI-ATIK-SİSTEMİ'
        });
        tiles.addTo(this.map);

    }

    async drawPoligons() {
        const coordinates: L.LatLng[] = [];
        var containers = [];

        this.order.forEach(x=>{
            containers.push(this.data[x])    
        })

        var garbageCenter = this.data[this.data.length - 1];
        var car = this.data[0];
        containers.pop();
        const marker = L.marker([garbageCenter.latitude, garbageCenter.longitude], { icon: new ContainerFormIcon({ iconUrl: 'assets/img/end.png' }) });
        marker.bindPopup(function () {
            let html = `<div> Tanım : ${garbageCenter.streetDesc}</div>`;
            return html;
        });
        marker.addTo(this.map)

        const markerCar = L.marker([car.latitude, car.longitude], { icon: new ContainerFormIcon({ iconUrl: 'assets/img/garbage-truck.png' }) });
        markerCar.addTo(this.map)

        var finishCoordinates = new L.latLng(garbageCenter.latitude, garbageCenter.longitude)

        containers.forEach(x => {
            if (x.latitude && x.longitude) {
                var map_icon;
                map_icon = new ContainerFormIcon({ iconUrl: 'assets/img/trash-red.png' })
                const marker = new L.marker([x.latitude, x.longitude], { icon: map_icon });
                coordinates.push(new L.latLng(x.latitude,x.longitude));
                marker.addTo(this.map)
            }
        });

        const start = L.Routing.control({
            waypoints: coordinates,
            lineOptions: {
                styles: [{ color: 'blue', opacity: 0.6, weight: 5 }]
            },
            plan: L.Routing.plan(
                coordinates,
                {
                    createMarker: function () {
                        return null;
                    }
                }
            ),
            serviceUrl: this.appConfigService.apiConfig["routing-url"],
            addWaypoints: false,
            autoRoute: true,
            fitSelectedRoutes: false,
            routeWhileDragging: false,
            draggableWaypoints: false,
            showAlternatives: false,
            createMarker: function () { return null; },
            show: false
        }).addTo(this.map);

        let destinationsback = coordinates.reverse();
        const finish = L.Routing.control({
            waypoints: [destinationsback[0], finishCoordinates ? finishCoordinates : L.latLng(car.latitude, car.longitude)],
            plan: L.Routing.plan(
                [destinationsback[0], finishCoordinates ? finishCoordinates : L.latLng(car.latitude, car.longitude)],
                {
                    createMarker: function () {
                        return null;
                    }
                }
            ),
            lineOptions: {
                styles: [{ color: 'red', opacity: 0.6, weight: 2 }]
            },
            serviceUrl: this.appConfigService.apiConfig["routing-url"],
            addWaypoints: false,
            autoRoute: true,
            fitSelectedRoutes: false,
            routeWhileDragging: false,
            draggableWaypoints: false,
            showAlternatives: false,
            createMarker: function () { return null; },
            show: false
        }).addTo(this.map);
    }
}
